import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addInventoryCategory, updateInventoryCategory } from 'features/inventory/invSettingsCategoriesSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const InventoryCategoryModal = ({ closeModal, value, subcategory, parentId }: { closeModal: any, value?: IInventoryCategoryModal, subcategory?: boolean, parentId?: number }) => {
    const [state, setState] = useState(value || {
        name: '',
        key: '',
        defaultCostingMethod: null,
        defaultTrackingMode: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //  @ts-ignore
        const resp = await dispatch(value?.id ? updateInventoryCategory({ category: { ...state }, fields: state.fields?.map(f => f.value) }) : addInventoryCategory({ category: state, parentId }))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const handleSelect = (v: ISelectValue, name: string) => {
        setState(prev => ({ ...prev, [name]: v }))
    }


    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%' mb='16' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Category</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Enter name' name='name' labelText='Name' value={state.name} onChange={handleChange} nomarg />
                {subcategory && <>
                    <HonestSelectInput labelText='Default Tracking Mode' options={defaultTrackingModeOptions} defaultValue={state.defaultTrackingMode?.value} onChange={handleSelect} name='defaultTrackingMode' nomarg />
                    <HonestSelectInput labelText='Default Costing Method' options={defaultCostingMethodOptions} defaultValue={state.defaultCostingMethod?.value} onChange={handleSelect} name='defaultCostingMethod' nomarg /></>}
            </Flex>
            <Button variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IInventoryCategoryModal {
    id?: number
    name: string
    parent: ISelectValue
    defaultTrackingMode: ISelectValue
    defaultCostingMethod: ISelectValue
    fields?: ISelectValue[]
}

export const defaultTrackingModeOptions = [
    { value: 1, label: 'None' },
    { value: 2, label: 'Batch' },
    { value: 3, label: 'Lot' },
    { value: 4, label: 'Serial' },
]

export const defaultCostingMethodOptions = [
    { value: 1, label: 'FIFO' },
    { value: 2, label: 'LIFO' },
    { value: 3, label: 'Weighted Average' },
    { value: 4, label: 'Standard' },
]